<script>
    import Router from 'svelte-spa-router'; // https://github.com/ItalyPaleAle/svelte-spa-router
    import routes from './routes.js';
    import TailwindCss from './TailwindCss.svelte';
</script>

<main>
    <Router routes={routes}  />
    <TailwindCss />
</main> 